

import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function Usersuspended({
    show,handleClose,
    type,
    suspenduser
}) {


  return (
    <Modal show={show} onHide={handleClose} className="delete-popup">
    <Modal.Header closeButton></Modal.Header>
    <Modal.Body>
    
      <p> Are you sure you want to suspend the account?</p>{" "}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={suspenduser}>
        Yes
      </Button>
      <Button variant="primary" onClick={handleClose}>
        No
      </Button>
    </Modal.Footer>
  </Modal>
  )
}